import { render } from "./ButtonLanguage.vue?vue&type=template&id=0e2ff31d&scoped=true"
import script from "./ButtonLanguage.vue?vue&type=script&lang=js"
export * from "./ButtonLanguage.vue?vue&type=script&lang=js"

import "./ButtonLanguage.vue?vue&type=style&index=0&id=0e2ff31d&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2ff31d"]])

export default __exports__